// extracted by mini-css-extract-plugin
export default {"text":"sort_item-module__text--2q157"};